// bs-options may break in later releases.

export const ftpSelectComponent = {
    name: 'ftpSelect',
    template: `     
    <button type="button"
            class="ftp-select"
            ims-tooltip="{{ $ctrl.dropdown ? '' : $ctrl.tooltip }}"
            ng-change="$ctrl.select.onChange()"
            ng-click="$ctrl.click()"
            ng-model="$ctrl.select.selectedOption"
            data-html="1"
            bs-options="o.value as o.label for o in $ctrl.select.options track by o.value"
            bs-select>   
            <span class="caret"></span>
    </button>
    `,
    bindings: {
        tooltip: '<',
        select: '<',
        click: '<',
        dropdown: '<',
    },
};
